import { apiClient } from './client'

export interface FindingDTO {
  id: number
  target_id: number | null
  asset_id: number | null
  sev: string
  title: string
  title_en: string | null
  host: string | null
  cve: string | null
  cvss: string | null
  kev: boolean
  status: string
  description: string | null
  matcher: Record<string, unknown>
  evidence: Record<string, unknown>
  created_at: string
}

export interface FindingCreate {
  target_id?: number
  asset_id?: number
  sev: string
  title: string
  title_en?: string
  host?: string
  cve?: string
  cvss?: string
  kev?: boolean
  status?: string
  description?: string
}

export const findingsApi = {
  list: (params?: { target_id?: number; asset_id?: number; sev?: string; kev_only?: boolean }) =>
    apiClient.get<FindingDTO[]>('/findings', { params }).then((r) => r.data),
  get: (id: number) => apiClient.get<FindingDTO>(`/findings/${id}`).then((r) => r.data),
  create: (body: FindingCreate) => apiClient.post<FindingDTO>('/findings', body).then((r) => r.data),
  update: (id: number, body: Partial<FindingCreate>) =>
    apiClient.patch<FindingDTO>(`/findings/${id}`, body).then((r) => r.data),
  remove: (id: number) => apiClient.delete(`/findings/${id}`).then(() => undefined),
}
